import Fields from '@/views/backstage/structure/frontstage_management/frequently_asked_question_management/common/FrequentlyAskedQuestionManagementFields'

let frequently_asked_question_structure=  {
    name: '常見問題Q&A管理',
    fields: [].concat(
        Fields['question'], 
        Fields['answer'],
    )
}

export default () => {
    return frequently_asked_question_structure
}